import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { PfuRequest } from '../interfaces/pfu-request.interface';
import { PfuResponse } from '../interfaces/pfu-response.interface';

@Injectable({
  providedIn: 'root',
})
export class PfuService {
  private readonly http = inject(HttpClient);

  public postPfuSimulation(request: Partial<PfuRequest>): Observable<PfuResponse> {
    return this.http.post<PfuResponse>('/rgg/fis/v1/pfu-simulation', request);
  }
}
